import BenefitsExperience from '@/components/redesign/BenefitsExperience';
export default function ServiceSmartLaderabat() {
  return <BenefitsExperience />;
}